<div class="text-center ui container">
    <h2>Liste des réservations</h2>
    <div class="ui icon input name-input">
        <input id="name" type="text" placeholder="Nom" [ngModel]="name" (ngModelChange)="onNameChanged($event)">
        <i class="search icon"></i>
    </div>
    <div *ngIf="filteredUserReservations.Value().length == 0">
        <h4>Pas de réservations</h4>
    </div>
    <admin-user-reservations *ngFor="let reservation of filteredUserReservations.Value()"
                             [userReservation]="reservation"
                             (moreDetails)="onDetailsRequired($event)"
                             (validated)="onValidated($event)"
                             (updated)="onUpdated(reservation)"
                             (removed)="onRemoved(reservation)">
    </admin-user-reservations>
    <admin-leasing-userReservation #userReservationDialog></admin-leasing-userReservation>
</div>


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/admin/reservations/presentation/presentation.html